import { render, staticRenderFns } from "./annualEducationTrendAnalysis.vue?vue&type=template&id=047da46c"
import script from "./annualEducationTrendAnalysis.vue?vue&type=script&lang=js"
export * from "./annualEducationTrendAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047da46c')) {
      api.createRecord('047da46c', component.options)
    } else {
      api.reload('047da46c', component.options)
    }
    module.hot.accept("./annualEducationTrendAnalysis.vue?vue&type=template&id=047da46c", function () {
      api.rerender('047da46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annual/trend/annualEducationTrendAnalysis.vue"
export default component.exports